import { render } from "./AddLiveData.vue?vue&type=template&id=49f9d400"
import script from "./AddLiveData.vue?vue&type=script&lang=js"
export * from "./AddLiveData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__